/**
 * PendingStatus - the Status cell of an S4 pending row and of its 390 card.
 *
 * The badge says Pending. When the source holds a result code the SPA cannot
 * map, the cell also carries the "unmapped" qualifier (PD-37 N12): the
 * unresolved classification is never silently hidden on the list surface. The
 * qualifier sits inside the Status cell, so the pending list gains no code
 * column (FR-4 stands). A pending row with no code, or a known one, is plain.
 */

import { UNMAPPED_TEXT, hasUnmappedCode } from './InvoiceTable'

export function PendingStatus({ rectNo, resultCd }: { rectNo: number; resultCd: string | null }) {
  return (
    <>
      <span className="status-badge--pending" data-testid={`pending-status-${rectNo}`}>
        Pending
      </span>
      {hasUnmappedCode(resultCd) && (
        <>
          {' · '}
          <mark className="unmapped-marker" data-testid={`pending-unmapped-${rectNo}`}>
            {UNMAPPED_TEXT}
          </mark>
        </>
      )}
    </>
  )
}
